import request from '@/utils/service'
export function GET_USER_LIST (params) {
  return request.get('/v1/user/selectUserList', {
    params
  })
}
export function GET_NEW_USER_LIST (params) {
  return request.get('/v1/data/share/user/pageTotalUnused', {
    params
  })
}
export function GET_USER_LIST_TOTAL (params) {
  return request.get('/v1/data/share/user/pageTotalCount', {
    params
  })
}
export function GET_TASK_PEOPLE (params) {
  return request.get('/v1/process/getTaskUserOfInstance', {
    params
  })
}
